import { render, staticRenderFns } from "./ChatbotTunePreview.vue?vue&type=template&id=0f07d227&scoped=true"
import script from "./ChatbotTunePreview.vue?vue&type=script&lang=js"
export * from "./ChatbotTunePreview.vue?vue&type=script&lang=js"
import style0 from "./ChatbotTunePreview.vue?vue&type=style&index=0&id=0f07d227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f07d227",
  null
  
)

export default component.exports